import React, { useCallback } from "react";

import "./SocialAuth.css";
import { useAppDispatch, useAppSelector } from "@store/store";
import { setAuthViewAction, selectAuthView } from "@store/sessionReducer";
import { SocialAuthButton } from "./SocialAuthButton";
import { selectClient } from "@store/client/clientReducer";

export type SocialAuthType = "facebook" | "google" | "sms" | "email";

const SocialAuth = ({ disabled }: { disabled: boolean }) => {
  const dispatch = useAppDispatch();
  const view = useAppSelector(selectAuthView);
  const client = useAppSelector(selectClient);

  const handlePress = useCallback(
    (type: "sms" | "email") =>
      async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();

        if (type === "sms") {
          dispatch(setAuthViewAction({ authView: "signInSms" }));
        }

        if (type === "email") {
          dispatch(setAuthViewAction({ authView: "signInEmail" }));
        }
      },
    [dispatch],
  );

  const endpoints = {
    facebook: "/users/auth/facebook",
    google: "/users/auth/google_oauth2",
  };

  return (
    <div className="social-auth-component">
      {/* TODO: Remove this once we have finished out phone auth for widget. */}
      {false /* client.userAuthenticationFeature.allowPhoneAuth */ &&
        view === "signInEmail" && (
          <SocialAuthButton
            provider="sms"
            onPress={handlePress("sms")}
            disabled={disabled}
          />
        )}
      {view === "signInSms" && (
        <SocialAuthButton
          provider="email"
          onPress={handlePress("email")}
          disabled={disabled}
        />
      )}
      <form action={endpoints.facebook} method="POST">
        <SocialAuthButton
          provider="facebook"
          disabled={disabled}
          htmlType="submit"
        />
      </form>
      {client.userAuthenticationFeature.allowGoogleAuth && (
        <form action={endpoints.google} method="POST">
          <SocialAuthButton
            provider="google"
            disabled={disabled}
            htmlType="submit"
          />
        </form>
      )}
    </div>
  );
};

export { SocialAuth };
